/** Angular Imports */
import { Component, OnInit } from '@angular/core';

/**
 * Bulk Import component.
 */
@Component({
  selector: 'mifosx-bulk-import',
  templateUrl: './bulk-import.component.html',
  styleUrls: ['./bulk-import.component.scss']
})
export class BulkImportComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
